module.exports = __webpack_public_path__ + "339a12d77fb3db489e26d1879024edef.png";